import { notification } from 'ant-design-vue';
import * as Cookies from "js-cookie";
import moment from "moment";
import { postData } from "./api-service";
import { LOG_OUT_USER } from "./api";
 
export const checkRes = param => {
    if (param === 200 || param === 201 || param === 212) {
        return true
    } else {
        return false
    }
}


export const errorHandle = res => {
    if (res && res.length > 0) {
      res.map(elem => {
        alertPop("error", elem);
      });
    } else {
      alertPop("error", "Check your internet connection!");
    }
};

export const alertPop = (type, data, title=null) => {
    notification[type]({
        message: title || `${type[0].toUpperCase()}${type.slice(1)}`,
        description: data,
    });
}

export const logoutUser = () => {
    console.log("hello");
    postData(LOG_OUT_USER, {}).then(res => {
        console.log(res);
        Cookies.remove('token');
        Cookies.remove('logistic-userinfo');
        sessionStorage.removeItem("logistic-userinfo");
        localStorage.removeItem('logistic-userinfo');
        localStorage.removeItem('fcmlogistic-token');
        window.location = "/auth/login";
    }).catch(error => {
        console.log(error);
        Cookies.remove('token');
        Cookies.remove('logistic-userinfo');
        sessionStorage.removeItem("logistic-userinfo");
        localStorage.removeItem('logistic-userinfo');
        localStorage.removeItem('fcmlogistic-token');
        window.location = "/auth/login";
    })
}

export const buildSearchQuery = (object) => {
    let query = "";

    for (const [key, value] of Object.entries(object)) {
        if (value) query = query + `&${key}=${value}`;
    }

    return query;
}

export const GAPI_KEY = () => {
    return "AIzaSyCsh7XFDtxpYE6tyBtvzR5qkS9hzTL27eI" //(office)
    // return "AIzaSyDYHdrfZls12TNU8m0ZJWZekQHFLieLhhI" // (my)
    // return "AIzaSyB41DRUbKWJHPxaFjMAwdrzWzbVKartNGg" // (google demo)
}

export const DateFormat = (date) => {
    if (date) {
        return moment(date).format('YYYY-MM-DD h:mm a');
    } else return null
}

export const checkUserPermission = (allow) => {
    let userSession = sessionStorage.getItem("logistic-userinfo-permission") ? JSON.parse(sessionStorage.getItem("logistic-userinfo-permission")) : '';
    let userCook = Cookies.get("logistic-userinfo-permission") ? JSON.parse(Cookies.get("logistic-userinfo-permission")) : '';
    let userInfo = JSON.parse(localStorage.getItem("logistic-userinfo")),
        userLocal = userInfo ? userInfo?.roles[0]?.permissions : [];


    let permissions = userSession ? userSession : userCook ? userCook : userLocal ? userLocal : '';

    if(permissions && permissions.length) {
        let array = permissions.map(per => per.slug);
        return array.includes(allow);

    } else return false;
}
